export function isBot () {
  const userAgent = navigator.userAgent.toLowerCase()

  const regex = /bot|crawl|slurp|spider|mediapartners|adsbot|googlebot|bingbot|yandexbot|duckduckbot|baiduspider|facebot|facebookexternalhit|ia_archiver/

  return regex.test(userAgent)
}
